"use client";

import React from "react";
import { Toaster } from "sonner";

interface ToastProviderProps {
  children: React.ReactNode;
}

export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <>
      {children}
      <Toaster position="bottom-right" />
    </>
  );
}
